function convertSecondsToReadable(diff: number): string {
  // diff is the saved time
  let hours = Math.floor(diff / 60 / 60);
  diff -= hours * 60 * 60;
  let minutes = Math.floor(diff / 60);
  diff -= minutes * 60;
  let seconds = Math.round(diff);
  // console.log(diff);
  // console.log(hours);
  return (
    (hours <= 9 ? "0" : "") +
    hours +
    ":" +
    (minutes <= 9 ? "0" : "") +
    minutes +
    ":" +
    (seconds <= 9 ? "0" : "") +
    seconds
  );
}
export function msToTime(duration: number) {
  const milliseconds = Math.floor(duration % 1000);
  let seconds: number = Math.floor((duration / 1000) % 60);
  let minutes: number = Math.floor((duration / (1000 * 60)) % 60);
  let hours: number = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = (hours < 10 ? "0" + hours : hours) as number;
  minutes = (minutes < 10 ? "0" + minutes : minutes) as number;
  seconds = (seconds < 10 ? "0" + seconds : seconds) as number;

  return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
}
type IMsToHMSType = {
  duration: number;
  format?: "h:m:s" | "h-m-s" | "h/m/s" | "h m s";
};
function getSuffixType({
  total = 0,
  suffix = "",
}: {
  total: number;
  suffix?: "h" | "m" | "s" | "";
}) {
  if (suffix) {
    const upperSuffix = suffix.toUpperCase();
    const lowerSuffix = suffix.toLowerCase();
    return [`${total} ${lowerSuffix}`, `${total} ${upperSuffix}`];
  }

  return total < 10 ? `0${total}` : `${total}`;
}
const getFormatTime = (
  time: {
    hours: string | number;
    minutes: number | string;
    seconds: number | string;
  },
  format: IMsToHMSType["format"] = "h:m:s"
) => {
  const { hours = 0, minutes = 0, seconds = 0 } = time;
  let newTime = hours + ":" + minutes + ":" + seconds;
  if (format === "h-m-s") {
    newTime = hours + "-" + minutes + "-" + seconds;
  } else if (format === "h/m/s") {
    newTime = hours + "/" + minutes + "/" + seconds;
  } else if (format === "h m s") {
    newTime = hours + " " + minutes + " " + seconds;
  }
  return newTime;
};

const getTime = ({
  hours = 0,
  minutes = 0,
  seconds = 0,
  milliseconds = 0,
  format = "h:m:s",
}: {
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
  format: IMsToHMSType["format"];
}) => {
  const [hoursWithLowerSuffix, hoursWithUpperSuffix] = getSuffixType({
    total: hours,
    suffix: "h",
  });
  const [minutesWithLowerSuffix, minutesWithUpperSuffix] = getSuffixType({
    total: minutes,
    suffix: "m",
  });
  const [secondsWithLowerSuffix, secondsWithUpperSuffix] = getSuffixType({
    total: seconds,
    suffix: "s",
  });
  const hoursWithOutPrefix = getSuffixType({
    total: hours,
  });
  const minutesWithOutPrefix = getSuffixType({
    total: minutes,
  });
  const secondsWithOutPrefix = getSuffixType({
    total: seconds,
  });
  const timeWithLowerSuffix = getFormatTime(
    {
      hours: hoursWithLowerSuffix,
      minutes: minutesWithLowerSuffix,
      seconds: secondsWithLowerSuffix,
    },
    format
  );
  const timeWithUpperSuffix = getFormatTime(
    {
      hours: hoursWithUpperSuffix,
      minutes: minutesWithUpperSuffix,
      seconds: secondsWithUpperSuffix,
    },
    format
  );
  const timeWithOutPrefix = getFormatTime(
    {
      hours: hoursWithOutPrefix as string,
      minutes: minutesWithOutPrefix as string,
      seconds: secondsWithOutPrefix as string,
    },
    format
  );
  let timeWidthMilisLowerSuffix =
    hoursWithLowerSuffix +
    ":" +
    minutesWithLowerSuffix +
    ":" +
    secondsWithLowerSuffix +
    "." +
    milliseconds;
  let timeWidthMilisUpperSuffix =
    hoursWithUpperSuffix +
    ":" +
    minutesWithUpperSuffix +
    ":" +
    secondsWithUpperSuffix +
    "." +
    milliseconds;
  return {
    timeWithOutPrefix,
    timeWithLowerSuffix,
    timeWithUpperSuffix,
    timeWidthMilisLowerSuffix,
    timeWidthMilisUpperSuffix,
  };
};
export function msToHMS(props: IMsToHMSType) {
  const { duration = 0, format = "h:m:s" } = props || {};
  const milliseconds = Math.floor(duration % 1000);
  let seconds: number = Math.floor((duration / 1000) % 60);
  let minutes: number = Math.floor((duration / (1000 * 60)) % 60);
  let hours: number = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const {
    timeWidthMilisLowerSuffix,
    timeWidthMilisUpperSuffix,
    timeWithLowerSuffix,
    timeWithUpperSuffix,
    timeWithOutPrefix,
  } = getTime({
    format,
    hours,
    milliseconds,
    minutes,
    seconds,
  });

  return {
    timeWidthMilisLowerSuffix,

    timeWidthMilisUpperSuffix,
    timeWithLowerSuffix,
    timeWithUpperSuffix,
    time: timeWithOutPrefix,
    hours,
    minutes,
    seconds,
  };
}
export const secondsToHMS = (props: IMsToHMSType) => {
  const { duration = 0, format = "h:m:s" } = props || {};
  const milliseconds = Math.floor(duration % 3600);
  let minutes: number = Math.floor((duration % 3600) / 60);
  let hours: number = Math.floor(duration / 3600);
  let seconds: number = Math.floor(duration % 60);

  const {
    timeWidthMilisLowerSuffix,
    timeWidthMilisUpperSuffix,
    timeWithLowerSuffix,
    timeWithUpperSuffix,
    timeWithOutPrefix,
  } = getTime({
    format,
    hours,
    milliseconds,
    minutes,
    seconds,
  });

  return {
    timeWidthMilisLowerSuffix,

    timeWidthMilisUpperSuffix,
    timeWithLowerSuffix,
    timeWithUpperSuffix,
    time: timeWithOutPrefix,
    hours,
    minutes,
    seconds,
  };
};
export function timeToMs(time: string) {
  if (!time) {
    return 0;
  }
  const [hours = 0, minutes = 0, seconds = 0] = time.split(":").map(Number);

  return (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
}
export default convertSecondsToReadable;
